import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { WORKSPACE_MODULES } from "@/data/exceptionHub";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export const ConnectedWorkspace = () => {
  return (
    <section id="workspace" className="relative py-24 md:py-32 bg-white" data-testid="section-workspace">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <Reveal><span className="text-xs font-semibold uppercase tracking-[0.15em] text-brand">Connected Workspace</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-navy tracking-tight leading-tight text-balance">
              One ecosystem. Issues flow from detection to resolved.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-ink-500 leading-relaxed">
              Exception Hub™ is a native DeMaxtore Workspace Product, connected to every module your operations rely on.
            </p>
          </Reveal>
        </div>

        <motion.div variants={stagger(0.1)} initial="hidden" whileInView="show" viewport={viewport}
          className="mt-16 flex flex-wrap items-center justify-center gap-4 md:gap-3">
          {WORKSPACE_MODULES.map((m, i) => {
            const Icon = Icons[m.icon] || Icons.Box;
            const active = i === 0;
            return (
              <div key={m.name} className="flex items-center gap-4 md:gap-3">
                <motion.div variants={fadeUp} whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 300, damping: 22 }}
                  className={`relative w-[168px] rounded-2xl border p-5 text-center transition-shadow ${m.done ? "bg-done-bg border-done-border" : active ? "bg-navy border-navy text-white shadow-float" : "bg-white border-slate-100 shadow-soft hover:shadow-card"}`}>
                  {active && (
                    <span className="absolute -top-2 left-1/2 -translate-x-1/2 text-[9px] font-semibold uppercase tracking-wider bg-brand text-white px-2 py-0.5 rounded-full">You are here</span>
                  )}
                  <span className={`mx-auto grid place-items-center h-12 w-12 rounded-xl ${m.done ? "bg-white text-done-text" : active ? "bg-white/10 text-white" : "bg-brand-soft text-brand"}`}>
                    <Icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                  <p className={`mt-3 text-sm font-semibold tracking-tight ${m.done ? "text-done-text" : active ? "text-white" : "text-navy"}`}>{m.name}</p>
                  <p className={`text-[11px] mt-0.5 ${m.done ? "text-done-text/70" : active ? "text-white/60" : "text-ink-400"}`}>{m.tag}</p>
                </motion.div>
                {i < WORKSPACE_MODULES.length - 1 && (
                  <motion.span variants={fadeUp} className="text-brand-connector hidden md:block"><ChevronRight className="h-6 w-6" strokeWidth={2} /></motion.span>
                )}
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
